// Última escolha de contexto lembrada só em localStorage, por `user.id` (REQ-FE-003). Nunca vai ao servidor.
export const CONTEXT_PREFERENCE_PREFIX = 'giyus.context.';

export interface ContextPreference {
  readonly tenantCode: string;
  readonly siteId: string | null;
}

export type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function preferenceKey(userId: string): string {
  return `${CONTEXT_PREFERENCE_PREFIX}${userId}`;
}

function isPreferenceLike(value: unknown): value is { tenantCode: string; siteId?: unknown } {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { tenantCode?: unknown }).tenantCode === 'string'
  );
}

export function readContextPreference(
  storage: PreferenceStorage | null | undefined,
  userId: string,
): ContextPreference | null {
  try {
    const raw = storage?.getItem(preferenceKey(userId));
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    if (!isPreferenceLike(parsed)) {
      return null;
    }
    return {
      tenantCode: parsed.tenantCode,
      siteId: typeof parsed.siteId === 'string' ? parsed.siteId : null,
    };
  } catch {
    return null;
  }
}

export function writeContextPreference(
  storage: PreferenceStorage | null | undefined,
  userId: string,
  preference: ContextPreference,
): void {
  try {
    storage?.setItem(preferenceKey(userId), JSON.stringify(preference));
  } catch {
    // armazenamento indisponível: conveniência local, nunca requisito
  }
}

export function clearContextPreference(
  storage: PreferenceStorage | null | undefined,
  userId: string,
): void {
  try {
    storage?.removeItem(preferenceKey(userId));
  } catch {
    // idem
  }
}

export function browserPreferenceStorage(): PreferenceStorage | null {
  return typeof localStorage === 'undefined' ? null : localStorage;
}
